/*
 * Susan Bratton email promo pages — shared behaviour.
 *
 * Markup contract (set by the promo-* sections):
 *   [data-sp-page-handle]                            any section root; sent as page_handle
 *   [data-sp-ga4-id]                                 GA4 measurement ID used as send_to (hero section)
 *   [data-track="susan-buy-now"][data-location]      fires susan_cta_click
 *   [data-track="susan-copy-code"][data-code]        copies the code, fires susan_promo_code_copy
 *   [data-sp-buy]               checkout link rebuilt from data-sp-buy-template when a size is chosen
 *   [data-sp-variant-select]    cylinder size <select>
 *   [data-sp-hero], [data-sp-offer-card], [data-sp-sticky]   sticky bar visibility
 *   video[data-sp-autoplay]     plays only while on screen
 */
(function () {
  if (window.SusanPromo) return;

  var state = { variantId: null };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pageHandle() {
    var el = document.querySelector('[data-sp-page-handle]');
    return el ? el.getAttribute('data-sp-page-handle') : '';
  }

  /* ---------- GA4 ---------- */

  // The storefront already has a Google tag for the GA4 property (loaded by the
  // theme's GTM container) plus a Merchant Center tag, both reading
  // window.dataLayer. A bare gtag('event') only reaches Merchant Center, so
  // every event is routed to GA4 with send_to. If gtag isn't defined yet, the
  // standard dataLayer shim queues the command until the Google tag loads.
  function ga4MeasurementId() {
    var el = document.querySelector('[data-sp-ga4-id]');
    var id = el ? (el.getAttribute('data-sp-ga4-id') || '').trim() : '';
    return /^G-[A-Z0-9]+$/i.test(id) ? id : '';
  }

  function trackGA4Event(eventName, params) {
    params = Object.assign({ page_handle: pageHandle(), transport_type: 'beacon' }, params || {});
    var measurementId = ga4MeasurementId();
    if (measurementId) params.send_to = measurementId;

    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== 'function') {
      window.gtag = function () { window.dataLayer.push(arguments); };
    }
    window.gtag('event', eventName, params);

    // Also expose the event to Shopify Customer Events (custom web pixels).
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        var detail = Object.assign({}, params);
        delete detail.transport_type;
        delete detail.send_to;
        window.Shopify.analytics.publish(eventName, detail);
      }
    } catch (e) {}
  }

  function announce(message) {
    var live = document.querySelector('[data-sp-live]');
    if (!live) return;
    live.textContent = '';
    window.setTimeout(function () {
      live.textContent = message;
    }, 50);
  }

  /* ---------- Copy promo code ---------- */

  function legacyCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    var ok = false;
    try {
      ok = document.execCommand('copy');
    } catch (e) {}
    document.body.removeChild(ta);
    return ok;
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).then(
        function () { return true; },
        function () { return legacyCopy(text); }
      );
    }
    return Promise.resolve(legacyCopy(text));
  }

  function handleCopy(el) {
    var code = el.getAttribute('data-code') || 'SUSAN';
    var labelEl = el.querySelector('[data-sp-copy-label]') || el;
    var original = labelEl.getAttribute('data-sp-original') || labelEl.textContent;
    var copiedLabel = el.getAttribute('data-sp-copied-label') || 'Copied!';
    labelEl.setAttribute('data-sp-original', original);

    trackGA4Event('susan_promo_code_copy', {
      promo_code: code,
      button_location: el.getAttribute('data-location') || 'unknown',
      page_path: window.location.pathname
    });

    copyText(code).then(function (ok) {
      if (!ok) return;
      el.classList.add('is-copied');
      labelEl.textContent = copiedLabel;
      announce('Code ' + code + ' copied to clipboard');
      window.clearTimeout(el._spTimer);
      el._spTimer = window.setTimeout(function () {
        el.classList.remove('is-copied');
        labelEl.textContent = original;
      }, 2000);
    });
  }

  /* ---------- Size-aware checkout links ---------- */

  function buildBuyUrl(link, variantId) {
    var template = link.getAttribute('data-sp-buy-template');
    if (!template || !variantId) return link.getAttribute('href');
    return template.replace('{variant_id}', encodeURIComponent(variantId));
  }

  function setVariant(variantId) {
    state.variantId = variantId || null;
    document.querySelectorAll('[data-sp-buy]').forEach(function (link) {
      if (!link.hasAttribute('data-sp-fallback-href')) {
        link.setAttribute('data-sp-fallback-href', link.getAttribute('href'));
      }
      link.setAttribute(
        'href',
        state.variantId ? buildBuyUrl(link, state.variantId) : link.getAttribute('data-sp-fallback-href')
      );
    });
    document.querySelectorAll('[data-sp-size]').forEach(function (wrap) {
      if (state.variantId) wrap.classList.remove('is-error');
    });
  }

  function requireSize(link) {
    if (state.variantId || !link.hasAttribute('data-sp-requires-variant')) return true;
    var wrap = document.querySelector('[data-sp-size]');
    var select = document.querySelector('[data-sp-variant-select]');
    if (!wrap || !select) return true;
    wrap.classList.remove('is-error');
    void wrap.offsetWidth; // restart the shake animation
    wrap.classList.add('is-error');
    wrap.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    select.focus({ preventScroll: true });
    announce('Please choose your cylinder size before ordering');
    return false;
  }

  /* ---------- In-page anchors ---------- */

  function scrollToHash(link) {
    var hash = link.getAttribute('href');
    if (!hash || hash.charAt(0) !== '#' || hash.length < 2) return false;
    var target = document.getElementById(hash.slice(1));
    if (!target) return false;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', hash);
    var select = target.querySelector('[data-sp-variant-select]');
    if (select && !state.variantId) {
      window.setTimeout(function () { select.focus({ preventScroll: true }); }, reduceMotion ? 0 : 600);
    }
    return true;
  }

  /* ---------- Click delegation ---------- */

  // One delegated listener: survives theme-editor section re-renders, and lets a
  // Buy Now click that's blocked for a missing size skip the analytics event.
  document.addEventListener('click', function (event) {
    var copyEl = event.target.closest('[data-track="susan-copy-code"]');
    if (copyEl) {
      event.preventDefault();
      handleCopy(copyEl);
      return;
    }

    var cta = event.target.closest('[data-track="susan-buy-now"]');
    if (!cta) return;

    if (cta.hasAttribute('data-sp-buy') && !requireSize(cta)) {
      event.preventDefault();
      return;
    }

    var href = cta.getAttribute('href') || '';
    trackGA4Event('susan_cta_click', {
      button_location: cta.getAttribute('data-location') || 'unknown',
      button_text: cta.innerText.trim(),
      page_path: window.location.pathname,
      destination_url: href,
      variant_id: state.variantId || ''
    });

    if (href.charAt(0) === '#' && scrollToHash(cta)) {
      event.preventDefault();
    }
  });

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-sp-variant-select]');
    if (select) setVariant(select.value);
  });

  /* ---------- Sticky bar + videos ---------- */

  function initSticky() {
    var bar = document.querySelector('[data-sp-sticky]');
    if (!bar) return;

    var hero = document.querySelector('[data-sp-hero]');
    // Watch the card itself, not the whole section, so the section's padding
    // peeking into view at the bottom of the page doesn't hide the bar.
    var offer = document.querySelector('[data-sp-offer-card]') || document.querySelector('[data-sp-offer]');
    var heroVisible = !!hero;
    var offerVisible = false;

    function update() {
      var show = !heroVisible && !offerVisible;
      bar.classList.toggle('is-visible', show);
      // Theme convention: lifts the floating contact icon above the bar.
      document.body.classList.toggle('sticky-shop-cta-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelectorAll('a, button').forEach(function (el) {
        if (show) el.removeAttribute('tabindex');
        else el.setAttribute('tabindex', '-1');
      });
    }

    if (!('IntersectionObserver' in window)) {
      heroVisible = false;
      update();
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target === hero) heroVisible = entry.isIntersecting;
        if (entry.target === offer) offerVisible = entry.isIntersecting;
      });
      update();
    }, { threshold: 0.05 });

    if (hero) io.observe(hero);
    if (offer) io.observe(offer);
    update();
  }

  function initVideos() {
    var videos = document.querySelectorAll('video[data-sp-autoplay]');
    if (!videos.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      videos.forEach(function (v) {
        v.setAttribute('controls', '');
        v.setAttribute('preload', 'metadata');
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          if (v.getAttribute('preload') === 'none') v.setAttribute('preload', 'auto');
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.35 });

    videos.forEach(function (v) { io.observe(v); });
  }

  function init() {
    var select = document.querySelector('[data-sp-variant-select]');
    var preset = document.querySelector('[data-sp-default-variant]');
    if (select && select.value) setVariant(select.value);
    else if (preset) setVariant(preset.getAttribute('data-sp-default-variant'));
    initSticky();
    initVideos();
  }

  window.SusanPromo = { track: trackGA4Event, setVariant: setVariant };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
